import { useCallback } from "preact/hooks";
import { useApp } from "~/core/store";

const useAccessCheck = () => {
    const {
        api: { service },
    } = useApp();
    const isLoading = service.loading.value;
    const isLoaded = service.loaded.value;
    const services = service.services.value;

    const check = useCallback(
        (access: readonly string[]) =>
            !isLoading &&
            access.every((key) =>
                services.find(
                    (service) => key === `${service.service}.${service.method}`,
                ),
            ),
        [isLoading, services],
    );

    return { check, isLoading, isLoaded };
};

export default useAccessCheck;
